import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Download } from "lucide-react";
import { toast } from "sonner";

export default function AdminNewsletter() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/newsletter").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const del = async (it) => {
        if (!confirm("Eintrag löschen?")) return;
        await api.delete(`/admin/newsletter/${it.id}`);
        toast.success("Gelöscht");
        load();
    };

    const exportCsv = () => {
        const rows = [["email", "language", "created_at"], ...items.map((i) => [i.email, i.language, i.created_at])];
        const csv = rows.map((r) => r.map((v) => `"${(v || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = "newsletter.csv"; a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="p-6 md:p-10 max-w-5xl">
            <div className="flex items-end justify-between gap-4 flex-wrap">
                <div>
                    <div className="text-[11px] font-bold uppercase tracking-widest text-brand-green">Newsletter</div>
                    <h1 className="mt-1 font-display text-3xl font-bold">Anmeldungen ({items.length})</h1>
                </div>
                <button onClick={exportCsv} className="btn-outline-dark" data-testid="newsletter-export"><Download className="h-4 w-4" />CSV exportieren</button>
            </div>

            <div className="mt-6 card-clean overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-brand-cream-dark/50 text-left text-xs uppercase tracking-widest text-brand-charcoal/70">
                        <tr>
                            <th className="px-4 py-3">E-Mail</th>
                            <th className="px-4 py-3">Sprache</th>
                            <th className="px-4 py-3">Angemeldet</th>
                            <th className="px-4 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it) => (
                            <tr key={it.id} className="border-t border-black/5">
                                <td className="px-4 py-3 font-medium">{it.email}</td>
                                <td className="px-4 py-3 uppercase text-xs text-brand-charcoal/60">{it.language || "de"}</td>
                                <td className="px-4 py-3 text-xs text-brand-charcoal/60">{new Date(it.created_at).toLocaleString()}</td>
                                <td className="px-4 py-3 text-right">
                                    <button onClick={() => del(it)} className="text-brand-red inline-flex h-8 w-8 items-center justify-center rounded-lg hover:bg-brand-cream-dark"><Trash2 className="h-4 w-4" /></button>
                                </td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr><td colSpan={4} className="px-4 py-10 text-center text-sm text-brand-charcoal/60">Noch keine Anmeldungen.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
